import { wsName } from "..";
import WsRoot from "./WsRoot";

export default class WsAccessor {
  private accessor: WsRoot;

  ensureAccessor() {
    if (!this.accessor) {
      this.accessor = window[wsName];
    }
    if (!this.accessor) {
      throw new Error("WebSockets are missing");
    }
  }

  configuration() {
    this.ensureAccessor();
    return this.accessor.configuration;
  }

  subscribe(messageType: string, handler: (e: CustomEvent) => void) {
    this.ensureAccessor();
    window.addEventListener(this.accessor.connection.getEventName(messageType), handler);
  }

  unsubscribe(messageType: string, handler: (e: CustomEvent) => void) {
    this.ensureAccessor();
    window.removeEventListener(this.accessor.connection.getEventName(messageType), handler);
  }

  sendNotificationRead(notificationId: string) {
    this.ensureAccessor();
    this.accessor.sendMessage("NotificationRead", { notificationId: notificationId });
  }

  sendAllNotificationsRead() {
    this.ensureAccessor();
    this.accessor.sendMessage("AllNotificationsRead", {});
  }

  sendHandoverRejected(handoverId: string, note: string) {
    this.ensureAccessor();
    this.accessor.sendMessage("HandoverRejected", {
      handoverId: handoverId,
      note: note,
    });
  }

  sendHandoverAccepted(handoverId: string, note: string) {
    this.ensureAccessor();
    this.accessor.sendMessage("HandoverAccepted", {
      handoverId: handoverId,
      note: note,
    });
  }
}
